export const isRequired = (value, msgParser) => {
  if (value) return undefined
  const errMsg = 'required field'
  return typeof msgParser === 'function' ? msgParser(errMsg) : errMsg
}

export const isValidEmail = (value, msgParser) => {
  const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  const errMsg = 'not valid email'
  return re.test(String(value).toLowerCase())
    ? undefined
    : typeof msgParser === 'function' ? msgParser(errMsg) : errMsg
}

export const isValidPhoneNumber = (value, msgParser) => {
  const re = /^(0|0041|\+41)?[1-9\s][0-9\s]{1,12}$/
  const errMsg = 'not valid phone'

  return re.test(String(value).toLowerCase())
    ? undefined
    : typeof msgParser === 'function' ? msgParser(errMsg) : errMsg
}

export const isValidPostalCode = (value, msgParser) => {
  const re = /^[1-9][0-9]{3,4}$/
  const errMsg = 'not valid postal code'

  return re.test(String(value).toLowerCase())
    ? undefined
    : typeof msgParser === 'function' ? msgParser(errMsg) : errMsg
}

export const isAtLeastOne = (value, msgParser) => {
  const errMsg = 'at least 1 field required'

  return value && value.length >= 1
    ? undefined
    : typeof msgParser === 'function' ? msgParser(errMsg) : errMsg
}

export function matchInputValidator(inputName) {
  switch (inputName) {
    case 'email':
      return isValidEmail
    case 'postal-code':
      return isValidPostalCode
    case 'phone':
      return isValidPhoneNumber
    default:
      return isRequired
  }
}
